import { FC } from "react";

import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	ITest,
	LabelPosition,
} from "@websential/cosmic-v20";

interface ISpecialDeductionsInfoFieldsPanel extends ITest {
	accountSettingsDDL:any;
}
export const SpecialDeductionsInfoFieldsPanel: FC<
	ISpecialDeductionsInfoFieldsPanel
> = ({ accountSettingsDDL }) => {
	return (
		<>
			<EnhancedDropDownRHFWithLabel
				label="Deduction"
				selectName="deduction"
				testId="deduction"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>
		</>
	);
};
